import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const InboxIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M16.8 3H7.2a3 3 0 0 0-2.6 1.7L1 11.5V18a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-6a1 1 0 0 0-.1-.5l-3.5-6.8A3 3 0 0 0 16.8 3Zm3.6 8-2.7-5.4a1 1 0 0 0-1-.6H7.3a1 1 0 0 0-.9.6L3.6 11H8c.3 0 .6.2.8.4l1.7 2.6h3l1.7-2.6c.2-.2.5-.4.8-.4h4.4ZM3 13v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-5h-4.5l-1.7 2.6a1 1 0 0 1-.8.4h-4a1 1 0 0 1-.8-.4L7.5 13H3Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default InboxIcon;
